// extracted by mini-css-extract-plugin
module.exports = {"linkMobile":"HorizontalNavigationItem_linkMobile__ia7_l","linkDesktop":"HorizontalNavigationItem_linkDesktop__sGxOl"};